import React from 'react';

class Share extends React.Component {

  render() {
    //  &nbsp;<img src={require('../images/heart.png')} alt="" width="18" height="18" />

    return (
      <div>
        <div className="modal" id="share" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 className="modal-title" id="myModalLabel">Share</h4>
              </div>
              <div className="modal-body">
                <div className="container-fluid">
                  <p className="text-center">
                    Recommend ClimateList to other travelers!
                  </p>
                  <p className="links">
                    <a href="https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Fclimatelist.com" className="facebook" target="_blank">
                      <img src={require('../images/facebook.png')} alt="" width="30" height="30" />
                    </a>
                    <a href="https://twitter.com/intent/tweet/?text=A%20map%20of%20countries%20with%20the%20ideal%20weather%20for%20each%20month%20of%20the%20year.%20Find%20the%20best%20time%20to%20travel%20with%20https%3A%2F%2Fclimatelist.com." className="twitter" target="_blank">
                      <img src={require('../images/twitter.png')} alt="" width="30" height="30" />
                    </a>
                    <a href="https://plus.google.com/share?url=https%3A%2F%2Fclimatelist.com" className="googleplus" target="_blank">
                      <img src={require('../images/googleplus.png')} alt="" width="30" height="30" />
                    </a>
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Share;



/** WEBPACK FOOTER **
 ** ./src/components/Share.js
 **/